export const TRANSACTION_PATH = "/transactions";
